import { Autocomplete, FormControl, ListItem, TextField, Typography } from "@mui/material";
import type { InternalEntity } from "../../../../../api/types/passthroughTypes";

interface Props {
  disabled?: boolean;
  value: InternalEntity | undefined;
  options: InternalEntity[];
  onChange: (value: InternalEntity | undefined) => void;
}

const InternalFundControl = ({ disabled, value, options, onChange }: Props) => {
  return (
    <FormControl size="small">
      <Autocomplete
        fullWidth
        value={value || null}
        options={options}
        onChange={(_, value) => onChange(value || undefined)}
        getOptionLabel={({ name }) => name}
        renderInput={(inputProps) => <TextField {...inputProps} placeholder={"Entity"} label={"Entity"} />}
        renderOption={({ key: _key, ...props }, option) => (
          <ListItem key={option.id} {...props}>
            <Typography>{option.name}</Typography>
          </ListItem>
        )}
        disabled={disabled}
      />
    </FormControl>
  );
};

export default InternalFundControl;
